import * as React from 'react';
import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, Fact, DimensionReference, existFactsInTable, generateLocalStateFromEventProperties,
    getSelectedAfr, updateTableFact, updateVersionStateValue
} from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { isAdmin, setIsDirty } from '../../redux/MiscSlice';
import { AccountEditorGridNoSubaccounts } from '../core/AccountEditorGridNoSubaccounts';
import {
    Alert, Button, Card, CardBody, CardTitle,FormFeedback, Input, Nav,
    NavItem, NavLink, TabContent, Table, TabPane, Toast, ToastBody, ToastHeader
} from 'reactstrap';
import utilityHelper from '../../utils/utilityHelper';
import { loadConcept, resetConceptState } from '../../redux/ConceptSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';



const DataElementWorksheetCalculated = (props: { userRole: string, defaultDewState: any }) => {
    const dispatch = useAppDispatch();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["workState_balanceSheetComplete", "workState_noBalanceSheet", "reviewState_balanceSheetReviewed"]));
    const [hasFacts, setHasFacts] = useState(true);
    const isAdminUser: boolean = useAppSelector(isAdmin);
    const [dewState, setDewState] = useState<any[]>([]);

    interface DewRow {
        rowType: string;
        name: string;
        code: string;
        includedAccounts: string;
        includedFunds: string;
        amount: number;
    }

    const loadDewAccount = (accountId?: string) => {
        if (accountId && accountId.length > 0) {
            dispatch(loadConcept({
                conceptId: "AccountCode_" + accountId,
                taxonomyType: currentAfr ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR,
                afrYear: afrYear
            }));
        } else {
            dispatch(resetConceptState({}));
        }
    }
    const addTotal = function (f: Fact, vs: any) {
        if (vs && vs.accountSource) {
            vs.accountSource.map((source: any) => {
                if (Number(source.min) <= Number(f.accountCode) && Number(source.max) >= Number(f.accountCode)) { 
                    if (source.hasOwnProperty("subFilter")) {
                        if (f.accountCode.indexOf(source.subFilter) > 0) {
                            vs.value = vs.value + f.value;
                        }
                    } else {
                        vs.value = vs.value + f.value;
                    }
                }
            })
        }
    }
    const populateDewData = function (facts: Fact[], dewState: any[]): any {
        var newState: any[] = JSON.parse(JSON.stringify(dewState));
        var valueSources: any = {};
        newState.map((section: any) => section.valueGroups.map((vg: any[]) => vg.map((v: any) => {
            var s : any = v.accountSource[0];
            var key = s.fund.charAt(0) + s.min.charAt(0);
            var sources: any[] = [];
            if (valueSources.hasOwnProperty(key)) {
                sources = valueSources[key];
            } else {
                valueSources[key] = sources;
            }
            sources.push(v);
        })));
        facts.map((f: Fact) => {
            if (f.accountCode && f.accountCode >= "1" && f.accountCode < "8" && f.dimensions) {
                var fgDim : DimensionReference | undefined = f.dimensions.find(d => d.axis.name === "Fund groups");
                if (fgDim !== undefined && fgDim.member) {
                    var fkey: string | null = null;
                    switch (fgDim.member.code) {
                        case "001":
                        case "100":
                        case "200":
                        case "300":
                        case "050":
                            fkey = "G" + f.accountCode.charAt(0);
                            break;

                        case "400":
                        case "500":
                            fkey = "P" + f.accountCode.charAt(0);
                            break;
                    }
                    if (fkey && valueSources.hasOwnProperty(fkey)) {
                        var vslist = valueSources[fkey];
                        vslist.map((vs: any) => addTotal(f, vs));
                    }
                }
            }
        });
        return newState;
    }
    const flattenDewState = function (ds: any[]): DewRow[] {
        var result : DewRow[] = [];
        ds.map((section: any) => {
            var sectHeader: DewRow = {
                rowType: "SectionHeader",
                name: section.name,
                code: "",
                includedAccounts: "",
                includedFunds: "",
                amount: 0
            };
            result.push(sectHeader);
            section.valueGroups.map((vg: any) => {
                var total: number = 0;
                vg.map((v : any) => {
                    var valueRow: DewRow = {
                        rowType: "ValueGroupRow",
                        name: v.name,
                        code: v.code,
                        includedAccounts: "",
                        includedFunds: v.fundGroup,
                        amount: v.value
                    }
                    total += v.value;
                    result.push(valueRow);
                });
                var valueGroupTotal: DewRow = {
                    rowType: "ValueGroupTotal",
                    name: "Total",
                    code: "",
                    includedAccounts: "",
                    includedFunds: "",
                    amount: total
                }
                result.push(valueGroupTotal);
            });
        });
        return result;
    };
    const getDewRowDefinition = function(dr: DewRow, idx : number) {
        switch (dr.rowType) {
            case "SectionHeader":
                return (
                    <tr onClick={() => { loadDewAccount(undefined) }}>
                        <td colSpan={3} style={{ backgroundColor:"#DDEBF7"}}>{dr.name}</td>
                    </tr>);
            case "ValueGroupRow":
                return (
                    <tr key={idx} onClick={() => { loadDewAccount(dr.code) } }>
                        <td>{dr.name}</td>
                        <td>{dr.includedFunds}</td>
                        <td style={{ textAlign: "right" }}>{utilityHelper.FormatterWithDecimals(dr.amount + "", "XBRLI_MONETARYITEMTYPE", 0)}</td>
                    </tr>);
            case "ValueGroupTotal":
                return (
                    <tr style={{ fontWeight: "bold" }} onClick={() => { loadDewAccount(undefined) }}>
                        <td style={{ borderTop: "1px solid black", borderBottom: "2px solid black" }}>{dr.name}</td>
                        <td style={{ borderTop: "1px solid black", borderBottom: "2px solid black" }}></td>
                        <td style={{ textAlign: "right", borderTop: "1px solid black", borderBottom: "2px solid black" }}>{utilityHelper.FormatterWithDecimals(dr.amount + "", "XBRLI_MONETARYITEMTYPE", 0)}</td>
                    </tr>);
                    
        }
        return <tr></tr>
    }
    React.useEffect(() => {

        // Saving pending changes to AfrSlice
        utilityHelper.saveDeferredChanges(dispatch);

    }, []);

    useEffect(() => {
        var newDewState = props.defaultDewState;
        if (currentAfr && currentAfr.currentversion) {
            var facts: Fact[] = [];
            currentAfr.currentversion.tables.map(t => {
                var tname = t.structure.name.toLowerCase();
                if (tname.indexOf("balance") >= 0 ||
                    tname.indexOf("rev") >= 0 ||
                    tname.indexOf("exp") >= 0
                ) {
                    t.rows.map(r => r.facts.map(f => facts.push(f)));
                }
            });
            newDewState = populateDewData(facts, props.defaultDewState);
        }
        setDewState(newDewState);
    }, [currentAfr]);

    return (
        <React.Fragment>
            <Toast className="auditDetail">
                <ToastHeader className="auditDetail">Data Element Worksheet</ToastHeader>
                <ToastBody>
                    <Table className="table dew" >
                        <thead className="scrollable-table-header thead-dark">
                            <tr key="header">
                                <th className="col-1">Account Code</th>
                                <th className="col-1">Included Funds</th>
                                <th className="col-1">Amount</th>
                            </tr>
                        </thead>

                        <tbody>
                            {flattenDewState(dewState).map((dr, idx) => 
                                getDewRowDefinition(dr, idx)
                            )}

                        </tbody>
                    </Table>
                </ToastBody>
            </Toast>
        </React.Fragment>
    );
}
export default DataElementWorksheetCalculated;